import type { Film } from "@/types/content";

export const films: Film[] = [
  {
    id: "neon-rain",
    title: "霓虹夜雨",
    originalTitle: "Neon Rain",
    year: 1992,
    region: "港台",
    categoryKey: "drama",
    categories: ["drama", "crime"],
    director: "陈可岚",
    cast: ["梁书言", "何嘉怡", "曾国维"],
    duration: 104,
    rating: 8.2,
    heat: 96,
    tags: ["经典", "修复版", "雨夜美学"],
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20poster%20art%20of%20a%20rain%20soaked%20city%20alley%20at%20night%20with%20magenta%20and%20amber%20neon%20reflections%20on%20wet%20asphalt%2C%20lone%20silhouette%20under%20an%20umbrella%2C%2035mm%20film%20grain%2C%20dramatic%20side%20lighting%2C%20no%20text%2C%20no%20lettering&width=800&height=1200&seq=film-neon-rain&orientation=portrait",
    synopsis:
      "一场持续十七天的雨困住了整座城市。夜班电台主持人在直播间接到来路不明的点歌，顺着声音找到了旧城区一间即将清拆的唱片行，也重新遇见了三年前不告而别的恋人。",
    review:
      "整部影片几乎没有白天，摄影把雨、霓虹和玻璃反光叠在一起，人物的情绪全部藏在烟和雨声里。修复版重新调整了色温，紫与橙的对比更清楚，是了解九十年代港产类型片绕不开的一部。",
  },
  {
    id: "rose-apartment",
    title: "玫瑰公寓",
    originalTitle: "Rose Apartment",
    year: 1995,
    region: "港台",
    categoryKey: "romance",
    categories: ["romance"],
    director: "林蔚",
    cast: ["苏晚", "程子衡", "方绮"],
    duration: 98,
    rating: 7.8,
    heat: 88,
    tags: ["经典", "都市爱情", "室内戏"],
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20cinematic%20poster%20art%20of%20a%20vintage%20apartment%20interior%20with%20dusty%20rose%20curtains%20and%20warm%20golden%20lamp%20glow%2C%20empty%20velvet%20armchair%20beside%20a%20tall%20window%2C%20soft%20haze%2C%20analog%20film%20grain%2C%20no%20text%2C%20no%20lettering&width=800&height=1200&seq=film-rose-apartment&orientation=portrait",
    synopsis:
      "玫瑰公寓十二楼只有三户人家。新搬来的租客发现邻居们每晚都会在同一个时间打开门，把一天的琐事讲给走廊听。她慢慢融进这种古怪的秩序，也开始收拾自己没说完的过去。",
    review:
      "典型的室内戏，九成场景都在一条走廊和两间屋子里完成，靠调度和台词撑起全部张力。全片金红色调，像老照片被灯照过一样温吞，适合一个人安静看完。",
  },
  {
    id: "between-tides",
    title: "潮汐之间",
    originalTitle: "Between Tides",
    year: 2001,
    region: "大陆",
    categoryKey: "drama",
    categories: ["drama", "urban"],
    director: "宋知远",
    cast: ["沈青", "罗亦然"],
    duration: 112,
    rating: 7.6,
    heat: 74,
    tags: ["文艺", "海边", "长镜头"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20a%20misty%20coastal%20shoreline%20at%20dawn%20with%20pale%20golden%20light%20and%20gentle%20waves%2C%20a%20distant%20lone%20figure%20walking%20on%20wet%20sand%2C%20muted%20cream%20and%20grey%20tones%2C%20film%20grain%2C%20no%20text&width=800&height=1200&seq=film-between-tides&orientation=portrait",
    synopsis:
      "靠海的小城要修一座新码头。测绘员住进渔村唯一还开着的小旅馆，白天量海岸线，晚上听老板娘讲这座城被潮水改写过几次边界，也讲她自己一直没有离开的原因。",
    review:
      "影片用了大量静止长镜头，把潮水涨落当作叙事节拍。对白很少，但信息量足够，是千禧年前后大陆独立制作里少见地克制的一部。",
  },
  {
    id: "silent-summer",
    title: "缄默的夏天",
    originalTitle: "The Silent Summer",
    year: 2008,
    region: "日本",
    categoryKey: "mystery",
    categories: ["mystery"],
    director: "石井遥",
    cast: ["中村澪", "杉浦健"],
    duration: 106,
    rating: 8.0,
    heat: 81,
    tags: ["悬疑", "夏日", "心理"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20a%20dim%20summer%20corridor%20with%20sunlight%20stripes%20through%20blinds%20and%20drifting%20dust%2C%20closed%20wooden%20door%2C%20cool%20shadows%20with%20warm%20highlights%2C%20grainy%20analog%20film%20look%2C%20no%20text&width=800&height=1200&seq=film-silent-summer&orientation=portrait",
    synopsis:
      "补习班老师每年暑假都会在同一间教室等一个不会来的学生。今年他收到一封没有署名的信，信里写着八年前那场停电的每一个细节，而这件事只有两个人知道。",
    review:
      "用声音做悬念的样本，蝉鸣、风扇和脚步的层次变化几乎承担了一半的叙事。结尾没有给出标准答案，但每个物品的摆放位置都在暗示发生了什么。",
  },
  {
    id: "midnight-neon",
    title: "午夜霓虹线",
    originalTitle: "Midnight Neon Line",
    year: 2012,
    region: "欧美",
    categoryKey: "crime",
    categories: ["crime", "urban"],
    director: "Daniel Ross",
    cast: ["Elena Marsh", "Tom Reilly"],
    duration: 118,
    rating: 7.4,
    heat: 79,
    tags: ["黑色电影", "公路", "夜戏"],
    cover:
      "https://readdy.ai/api/search-image?query=Neon%20noir%20cinematic%20poster%20art%20of%20a%20rain%20slick%20city%20street%20at%20midnight%20with%20orange%20streetlights%20and%20purple%20haze%2C%20vintage%20car%20headlights%2C%20mirror%20reflections%20on%20the%20road%2C%2035mm%20grain%2C%20no%20text&width=800&height=1200&seq=film-midnight-neon&orientation=portrait",
    synopsis:
      "一名夜班代驾在同一个路口连续三晚接到同一位客人，目的地每次都写着一个不存在的门牌号。当他决定跟上去看看，才发现这座城市凌晨三点的路线图另有版本。",
    review:
      "摄影机几乎一直贴着车窗，观众和主角一起被城市灯光推着走。叙事不算复杂，但氛围做得很完整，适合喜欢公路黑色电影的观众。",
  },
  {
    id: "glass-mask",
    title: "玻璃假面",
    originalTitle: "Glass Mask",
    year: 2015,
    region: "韩国",
    categoryKey: "romance",
    categories: ["romance", "mystery"],
    director: "尹智浩",
    cast: ["韩素妍", "姜文宰"],
    duration: 110,
    rating: 7.9,
    heat: 85,
    tags: ["双线叙事", "都市", "近作"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20a%20translucent%20glass%20mask%20resting%20on%20dark%20velvet%20with%20soft%20golden%20rim%20light%20and%20deep%20violet%20shadows%2C%20elegant%20mysterious%20still%20life%2C%20film%20grain%2C%20no%20text&width=800&height=1200&seq=film-glass-mask&orientation=portrait",
    synopsis:
      "配音演员替一位从不露面的作家录制有声书，录到第七章时发现书里的细节与自己童年完全吻合。她开始尝试联系作者，而对方只回了一句话：请不要读到最后一页。",
    review:
      "两条时间线交叉推进，靠声音而非画面完成转场，是近年类型片里比较聪明的处理。爱情线与悬疑线相互咬合，最后十五分钟收得很漂亮。",
  },
  {
    id: "spring-hotel",
    title: "春潮旅馆",
    originalTitle: "Spring Tide Hotel",
    year: 1998,
    region: "日本",
    categoryKey: "drama",
    categories: ["drama"],
    director: "高木修",
    cast: ["小林京子", "松田隆"],
    duration: 101,
    rating: 7.7,
    heat: 70,
    tags: ["经典", "温泉", "群像"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20a%20quiet%20old%20hotel%20corridor%20with%20paper%20lanterns%20and%20wooden%20lattice%20windows%2C%20warm%20amber%20glow%20and%20soft%20haze%2C%20analog%20film%20texture%2C%20no%20text&width=800&height=1200&seq=film-spring-hotel&orientation=portrait",
    synopsis:
      "山间旅馆在闭馆前迎来最后一批客人。老板娘按老规矩为每个人准备一间朝向不同的房间，也准备了四段互不相干的故事，直到停电那一夜，所有人的门都被推开了。",
    review:
      "结构像一本短篇集，段落之间用走廊的空镜连接。美术非常讲究，木构、纸灯与雨声构成一个封闭又温柔的空间。",
  },
  {
    id: "white-echo",
    title: "白色回声",
    originalTitle: "White Echo",
    year: 2019,
    region: "欧美",
    categoryKey: "drama",
    categories: ["drama"],
    director: "Clara Weiss",
    cast: ["Nora Vance", "Peter Lough"],
    duration: 124,
    rating: 8.1,
    heat: 76,
    tags: ["黑白", "低温美学", "获奖"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20a%20snow%20covered%20empty%20street%20with%20a%20single%20streetlamp%20glowing%20warm%20gold%20against%20pale%20violet%20dusk%2C%20minimal%20composition%2C%2035mm%20grain%2C%20no%20text&width=800&height=1200&seq=film-white-echo&orientation=portrait",
    synopsis:
      "大雪封城的第三天，一名声音采集师被困在郊区录音棚。她开始录下雪落下的声音，却在回放里听见了不属于这座房子的脚步，以及一段自己从未说过的话。",
    review:
      "声音设计与画面同样重要，甚至可以说这是一部需要用耳机看的电影。极简的布景把注意力全部交给表演和音场，冷静但后劲很足。",
  },
  {
    id: "twin-flowers",
    title: "双生花",
    originalTitle: "Twin Flowers",
    year: 2004,
    region: "港台",
    categoryKey: "romance",
    categories: ["romance"],
    director: "周漫",
    cast: ["叶桐", "叶槿", "黎岸"],
    duration: 96,
    rating: 7.5,
    heat: 68,
    tags: ["双女主", "旧宅", "细腻"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20two%20overlapping%20dried%20flowers%20casting%20long%20shadows%20on%20a%20cream%20plaster%20wall%2C%20warm%20dusty%20light%2C%20elegant%20minimal%20still%20life%2C%20analog%20grain%2C%20no%20text&width=800&height=1200&seq=film-twin-flowers&orientation=portrait",
    synopsis:
      "姐姐留下一栋老房子和一本只写了半本的日记便离开了。妹妹搬进去整理遗物，逐渐发现日记里的另一个人，其实一直住在隔壁，并且认识她比自己以为的更久。",
    review:
      "两位女主角的表演撑起了全片，很多段落只有眼神和停顿。影片对旧宅空间的使用很聪明，同一个房间在不同时间呈现出完全不同的气质。",
  },
  {
    id: "alley-detective",
    title: "暗巷侦探",
    originalTitle: "Alley Detective",
    year: 2017,
    region: "港台",
    categoryKey: "crime",
    categories: ["crime", "mystery"],
    director: "麦启言",
    cast: ["邓子墨", "罗嘉敏"],
    duration: 114,
    rating: 8.3,
    heat: 92,
    tags: ["热播", "推理", "旧城区"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20a%20narrow%20old%20town%20alley%20at%20dusk%20with%20amber%20lamps%2C%20hanging%20wires%20and%20shadowed%20stone%20stairs%2C%20mysterious%20noir%20atmosphere%2C%2035mm%20film%20grain%2C%20no%20text&width=800&height=1200&seq=film-alley-detective&orientation=portrait",
    synopsis:
      "旧城区接连发生失窃案，丢的都是不值钱的东西：一只旧钟、一张唱片、一张合影。退休警探接了这桩没人愿意管的委托，沿着巷子里的灯一路查到自己的旧住址。",
    review:
      "推理部分扎实，线索都摆在明面上，观众有机会比主角更早想通。街区实景拍得极好，是近年港产类型片里口碑很稳的一部。",
  },
  {
    id: "tide-city-letter",
    title: "潮汐城的信",
    originalTitle: "Letters from the Tide City",
    year: 2021,
    region: "大陆",
    categoryKey: "drama",
    categories: ["drama", "urban"],
    director: "顾清和",
    cast: ["白小满", "赵恒"],
    duration: 108,
    rating: 7.8,
    heat: 83,
    tags: ["近作", "书信", "城市"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20a%20sealed%20letter%20and%20a%20vintage%20camera%20on%20a%20windowsill%20overlooking%20a%20grey%20harbor%2C%20soft%20morning%20light%2C%20muted%20warm%20tones%2C%20film%20grain%2C%20no%20text&width=800&height=1200&seq=film-tide-city-letter&orientation=portrait",
    synopsis:
      "老邮局要关闭了，最后一批无人认领的信被摆上了柜台。临时来帮忙整理的大学生决定按地址送出去，其中一封的收件人，已经在二十年前搬离了这座城市。",
    review:
      "一部关于「送达」的电影，节奏温和，情绪递进得很自然。城市的旧街区与新建筑交替出现，构成一条不太声张的时间线。",
  },
  {
    id: "maze-tower",
    title: "迷楼",
    originalTitle: "The Maze Tower",
    year: 2023,
    region: "日本",
    categoryKey: "mystery",
    categories: ["mystery"],
    director: "森川绫",
    cast: ["藤井纱", "大岛圭"],
    duration: 117,
    rating: 8.4,
    heat: 95,
    tags: ["热播", "近作", "建筑"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20a%20spiraling%20stairwell%20lit%20by%20a%20single%20warm%20lamp%2C%20deep%20violet%20shadows%20and%20geometric%20architecture%2C%20mysterious%20mood%2C%20analog%20grain%2C%20no%20text&width=800&height=1200&seq=film-maze-tower&orientation=portrait",
    synopsis:
      "一栋只有十一层的公寓，电梯按钮却排到了十三。新搬来的住客每次上错楼层，都会看到同一间屋子摆着不同的家具。物业说这栋楼从来只有十一层。",
    review:
      "近两年最会玩空间的悬疑片，电梯、楼梯与走廊构成一个完整的迷宫结构。声效与剪辑都很精确，结尾留白但不敷衍。",
  },
  {
    id: "pink-signal",
    title: "粉色信号",
    originalTitle: "Pink Signal",
    year: 2010,
    region: "欧美",
    categoryKey: "romance",
    categories: ["romance", "urban"],
    director: "Mia Delacroix",
    cast: ["Lila Grant", "Owen Pike"],
    duration: 99,
    rating: 7.3,
    heat: 65,
    tags: ["复古", "电台", "轻喜剧"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20a%20vintage%20radio%20glowing%20warm%20orange%20on%20a%20table%20beside%20sheer%20curtains%20at%20dusk%2C%20soft%20pastel%20pink%20and%20gold%20light%2C%20nostalgic%20still%20life%2C%20film%20grain%2C%20no%20text&width=800&height=1200&seq=film-pink-signal&orientation=portrait",
    synopsis:
      "深夜电台的两位主播从未见过面，却在节目里默契得像老朋友。频率要被收回的消息传来，他们决定在空中做最后一期节目，并且都不打算说出自己的真实姓名。",
    review:
      "轻松、明快，色调是全站最粉的一部。虽然故事走向不难猜，但台词写得聪明，看的时候很放松。",
  },
  {
    id: "fog-harbor",
    title: "雾港往事",
    originalTitle: "Tales of the Fog Harbor",
    year: 1989,
    region: "港台",
    categoryKey: "crime",
    categories: ["crime", "drama"],
    director: "郑北岸",
    cast: ["卢振声", "陈玉珊"],
    duration: 103,
    rating: 8.0,
    heat: 87,
    tags: ["经典", "码头", "年代感"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20a%20foggy%20harbor%20with%20old%20cargo%20cranes%20silhouetted%20against%20amber%20sunset%2C%20calm%20water%20reflections%2C%20nostalgic%20nineteen%20eighties%20film%20texture%2C%20no%20text&width=800&height=1200&seq=film-fog-harbor&orientation=portrait",
    synopsis:
      "码头工人阿荣替人代收一只没有清单的箱子，第二天箱子不见了，来问话的人越来越多。他带着妻子躲进港口边的旧仓库，才发现自己想守住的其实不是箱子。",
    review:
      "八十年代末港产类型片的代表作之一，雾、船笛与铁皮仓库构成了极强的年代质感。叙事朴实，人物关系交代得干净利落。",
  },
  {
    id: "long-night-mailbox",
    title: "长夜信箱",
    originalTitle: "The Long Night Mailbox",
    year: 2016,
    region: "大陆",
    categoryKey: "drama",
    categories: ["drama"],
    director: "何知微",
    cast: ["林叙", "周雨棠"],
    duration: 105,
    rating: 7.6,
    heat: 72,
    tags: ["小成本", "夜戏", "治愈"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20a%20small%20green%20mailbox%20under%20a%20warm%20streetlight%20on%20a%20quiet%20night%20street%2C%20soft%20orange%20glow%2C%20gentle%20rain%20haze%2C%20film%20grain%2C%20no%20text&width=800&height=1200&seq=film-long-night-mailbox&orientation=portrait",
    synopsis:
      "夜班保安在写字楼大堂发现一个没人使用的信箱，里面每天都有一封写给「明天」的信。他按规矩没有拆开，直到某天信上的字迹变成了自己的。",
    review:
      "低成本的温柔小品，一个场景、两个人物，把观众留在了夜班的安静里。结尾的处理克制，不做多余的煽情。",
  },
  {
    id: "sunset-station",
    title: "落日车站",
    originalTitle: "Sunset Station",
    year: 1987,
    region: "港台",
    categoryKey: "drama",
    categories: ["drama"],
    director: "吴锦堂",
    cast: ["郑念", "许晴川"],
    duration: 95,
    rating: 7.9,
    heat: 66,
    tags: ["经典", "火车站", "年代"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20an%20old%20train%20station%20platform%20at%20sunset%20with%20long%20shadows%20and%20empty%20benches%2C%20warm%20amber%20sky%2C%20nostalgic%20eighties%20film%20grain%2C%20no%20text&width=800&height=1200&seq=film-sunset-station&orientation=portrait",
    synopsis:
      "小站每天只有两班车停靠。站长在这里守了二十年，送走过无数人，唯独没有等到当年说会回来的人。新来的售票员开始替他记账，也替他记下每天的时间。",
    review:
      "节奏很慢，但情感浓度高。落日的暖光贯穿全片，最后一场戏的远景长镜头是许多人记住这部电影的原因。",
  },
  {
    id: "cold-rain-taxi",
    title: "冷雨出租车",
    originalTitle: "Cold Rain Taxi",
    year: 2003,
    region: "港台",
    categoryKey: "crime",
    categories: ["crime"],
    director: "冯志豪",
    cast: ["杜文杰", "叶丽珊"],
    duration: 100,
    rating: 7.5,
    heat: 71,
    tags: ["夜班", "城市", "跟踪"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20a%20taxi%20stopped%20on%20a%20rainy%20street%20at%20night%20with%20warm%20tail%20lights%20and%20blue%20grey%20rain%20haze%2C%20lonely%20urban%20mood%2C%20film%20grain%2C%20no%20text&width=800&height=1200&seq=film-cold-rain-taxi&orientation=portrait",
    synopsis:
      "出租车司机老周跑夜班二十年，记得每一位乘客的下车地点。最近一个月，同一名乘客每周三都会在同一个路口上车，带着同样一只湿透的纸袋。",
    review:
      "把一个极小的切口拍成了完整的城市观察。大部分时间镜头都在车内，观众透过挡风玻璃看城市，紧张感却一点点积累起来。",
  },
  {
    id: "mirror-visitor",
    title: "镜中访客",
    originalTitle: "The Mirror Visitor",
    year: 2020,
    region: "韩国",
    categoryKey: "mystery",
    categories: ["mystery"],
    director: "朴成恩",
    cast: ["徐允儿", "李到勋"],
    duration: 113,
    rating: 8.2,
    heat: 89,
    tags: ["近作", "心理", "双时间线"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20a%20large%20antique%20mirror%20in%20a%20dim%20room%20with%20soft%20amber%20light%20and%20deep%20violet%20shadow%2C%20mysterious%20atmosphere%2C%20film%20grain%2C%20no%20text&width=800&height=1200&seq=film-mirror-visitor&orientation=portrait",
    synopsis:
      "画廊修复师接到一面十九世纪的镜子，清洗镜面时发现倒影里的房间多了一扇门。她开始记录每次倒影的变化，而记录本上出现了不属于自己的笔迹。",
    review:
      "心理悬疑处理得很细，恐怖感来自日常物件的位置变化而不是突然的惊吓。美术与灯光是这部片最值得看的部分。",
  },
  {
    id: "evening-wind-letter",
    title: "晚风与信",
    originalTitle: "Letters in the Evening Wind",
    year: 2018,
    region: "日本",
    categoryKey: "romance",
    categories: ["romance"],
    director: "白石葵",
    cast: ["小野遥", "佐伯悠"],
    duration: 102,
    rating: 7.7,
    heat: 73,
    tags: ["治愈", "夏夜", "书信"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20handwritten%20letters%20on%20a%20wooden%20desk%20by%20an%20open%20window%20with%20evening%20breeze%20and%20warm%20lamp%20light%2C%20gentle%20nostalgic%20mood%2C%20analog%20grain%2C%20no%20text&width=800&height=1200&seq=film-evening-wind-letter&orientation=portrait",
    synopsis:
      "海边小镇的文具店老板替人代写信，二十年来从不问内容。某天一位客人要求写一封「寄不出去」的信，收件人写着他自己的名字。",
    review:
      "温柔到几乎不设冲突的一部电影，靠细节和季节感推进。夏天的风、信纸的声响和巷口的自动贩卖机，构成了完整的记忆场景。",
  },
  {
    id: "midnight-store",
    title: "午夜便利店",
    originalTitle: "Midnight Store",
    year: 2022,
    region: "大陆",
    categoryKey: "urban",
    categories: ["urban"],
    director: "陆一鸣",
    cast: ["姜禾", "许南"],
    duration: 97,
    rating: 7.4,
    heat: 78,
    tags: ["近作", "都市", "群像"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20art%20of%20a%20glowing%20convenience%20store%20window%20on%20an%20empty%20night%20street%2C%20warm%20interior%20light%20spilling%20onto%20wet%20pavement%2C%20quiet%20urban%20mood%2C%20film%20grain%2C%20no%20text&width=800&height=1200&seq=film-midnight-store&orientation=portrait",
    synopsis:
      "凌晨两点的便利店是这座城市最后亮着的窗口。新来的夜班店员慢慢记住了固定客人的购买习惯，也发现每个人的清单背后都藏着一点没说出口的心事。",
    review:
      "轻巧的都市群像，用商品和对话完成人物速写。节奏松弛，适合深夜随便点开一集当作陪伴。",
  },
];